import { Fragment } from 'react';
import './projetos.css';

import { Link } from 'react-router-dom'

export default function Projetos() {

    const projetos = [
        {
            imgProjeto: 'https://img.freepik.com/vetores-gratis/ilustracao-do-conceito-de-login-movel_114360-83.jpg?w=826&t=st=1682956758~exp=1682957358~hmac=22a2c5cdfca6c5f141e6befe64fc0c3187723b88ce1d877bc36719b2c1698aeb',
            sobreProjeto: 'Projeto Feito com HTML e CSS, criando um formulario de Login, aplicando os conceitos de FlexBox CSS e responsividade',
            linkProjeto: 'https://loginjlms.netlify.app/',
            altImage: "Projeto Tela de Login"
        },

        {
            imgProjeto: 'https://img.freepik.com/vetores-gratis/conceito-abstrato-de-sistema-de-controle-de-acesso_335657-3180.jpg?w=826&t=st=1682957437~exp=1682958037~hmac=a8679f2e9fb31a9505b6ba1caa5d7562909d9339bd448881028edfeb079dcded',

            sobreProjeto: 'Projeto Feito com HTML CSS e JS, criando um Formulario de Login, usando validação de Campos e mostrando alertas no modelo Toast, usando ToastifyJS ',

            linkProjeto: 'https://jlms-login.netlify.app/',

            altImage: "Projeto Tela de Login com Validações"
            
        },

        {
            imgProjeto: 'https://img.freepik.com/vetores-gratis/pagina-inicial-de-negocios-criativos_52683-60296.jpg?w=1380&t=st=1682957662~exp=1682958262~hmac=42739d061d7365e08d1f36a481ff8683ab97e365f57204a3892ad370bef10964',

            sobreProjeto: 'Projeto Feito com HTML e CSS, desenvolvendo uma Landing Page, com formulario de captação de Dados',

            linkProjeto: 'https://jlmsdevtech.netlify.app/',

            altImage: "Projeto Landing Page DevTech"
            
        },

        {
            imgProjeto: 'https://cdn-icons-png.flaticon.com/512/841/841378.png?w=826&t=st=1682957891~exp=1682958491~hmac=f56375ce5fa6d11c65e5dbf16612a1fb387bd12851f6b8d031d7ac0c2df912d6',

            sobreProjeto: 'Projeto Feito com HTML e CSS, desenvolvendo uma Landing Page, de encurtador de Links',

            linkProjeto: 'https://jlms-encurta.netlify.app/',

            altImage: "Projeto Landing Page encurtador de Links"
            
        },

        {
            imgProjeto: 'https://img.freepik.com/vetores-gratis/colecao-de-lista-de-precos_23-2148106546.jpg?w=826&t=st=1682958831~exp=1682959431~hmac=c9a8ffaab482bbe45227fc78ec39f1f1c5d539090eeb441b861960eb75995c85',

            sobreProjeto: 'Projeto Feito com HTML e CSS, desenvolvendo componentes de Preços, com Planos de Uso ficticios',

            linkProjeto: 'https://jlmspricing.netlify.app/',

            altImage: "Projeto mostrando componentes de Preços."
            
        },

        {
            imgProjeto: 'https://img.freepik.com/vetores-gratis/trabalhador-com-duvidas_1012-193.jpg?size=626&ext=jpg&ga=GA1.2.1345993045.1682956735&semt=sph',

            sobreProjeto: 'Projeto Feito com HTML e CSS, desenvolvendo componentes de Duvidas, usando os proprios elementos Nativos do HTML',

            linkProjeto: 'https://jlms-componente-duvidas.netlify.app/',

            altImage: "Projeto mostrando componentes de Duvidas."
            
        },

        {
            imgProjeto: 'https://img.freepik.com/vetores-gratis/grafico-de-informacoes-bmi-de-indice-de-massa-corporal-de-mulheres_90220-261.jpg?w=1380&t=st=1682959131~exp=1682959731~hmac=b5b6ff97d4588418a3ec89c60e081ed3698a6a6fe91a6608214b154f00108d14',

            sobreProjeto: 'Projeto Feito com HTML CSS e Javascript, desenvolvendo uma mini Calculadora de IMC',

            linkProjeto: 'https://jlms-calcimc.netlify.app/',

            altImage: "Projeto Mini Calculadora de IMC"
            
        },

        {
            imgProjeto: 'https://img.freepik.com/vetores-gratis/ilustracao-de-pessoa-digitalizando-um-codigo-qr-com-um-smartphone_23-2148621302.jpg?w=826&t=st=1682959340~exp=1682959940~hmac=feb5da41e46539859a59c10f1e1072f1572c034eaca4594697329591dd7c3f0d',

            sobreProjeto: 'Projeto Feito em ReactJs, desenvolvendo um Gerador de QRcode, para baixar links, imagens etc, Gratuito.',

            linkProjeto: 'https://jlms-qrcode.netlify.app/',

            altImage: "Projeto Gerador de QrCode"
            
        },

        {
            imgProjeto: 'https://img.freepik.com/vetores-gratis/respingo-do-instagram-nas-redes-sociais_125540-360.jpg?w=900&t=st=1684372565~exp=1684373165~hmac=dd0fddc3d042b79d12fd1880bf495aecf60c58e8ed10fca6bbf6b472a604cc7b',

            sobreProjeto: 'Recriando Interface do Instagram, usando HTML e CSS e conceitos de FLEXBOX',

            linkProjeto: 'https://melogram.netlify.app/',

            altImage: "Formulario de Login da Pagina Instagram"
            
        },

        {
            imgProjeto: 'https://img.freepik.com/vetores-gratis/ilustracao-do-conceito-de-lista-de-notas-moveis_114360-2347.jpg?w=740&t=st=1687912947~exp=1687913547~hmac=bc9d2605100b6b0672d9b12873836e9d323cea3edb98f4c68bbc92412f71cff1',

            sobreProjeto: 'Um Projeto Lista de Tarefas, com autenticação de Usuario, para que você possa guardar suas tarefas, em uma base de dados da Google Firestore',

            linkProjeto: 'https://jlms-listatarefas.netlify.app/',

            altImage: "Projeto Lista de Tarefas"
            
        }

        
    ]

    return(
        <Fragment>
            <div className='tituloPagina'>
                <span>Projetos</span>
                <Link to='/'>Voltar</Link>
            </div>

            <div className='containerProjetos'>

                <div className='cardProjetos'>

                    {projetos.map( (item) => (
                        
                    <div key={item.linkProjeto} className='projeto'>
                        <img className='imgProject' src={ item.imgProjeto } alt={ item.altImage } />

                        <span className='sobreProjeto'> { item.sobreProjeto }</span>

                        <a className='btnProjeto' href={ item.linkProjeto } target='blank'>Acessar Projeto </a>
                    </div>

                    ) ) };

                </div>

            </div>
        </Fragment>
    );
}
